//@flow
import {
  USER_SET,
  USER_UNSET,
  USER_MODIFY_PICTURE,
  USER_MODIFY,
  USER_REQUESTING,
  USER_MODIFY_REQUESTING,
  USER_FOCUS,
  USER_UNFOCUS,
  USER_ADD_DEVICE_ID,
  USER_SEND_PULSE_NOTIFICATION_REQUESTING,
  USER_GET_COMPANY_LOGO_REQUESTING,
  UPDATE_USER_WITHOUT_RESPONSE_REQUESTING,
  MY_USERS_DELETE_REQUESTING,
} from "./constants";

type payloadType = {
  picture?: string;
  title?: string;
  email?: string;
  name?: string;
};

type addFriendType = {
  userId: string;
  friendId: string;
};

type hideFriendRequestType = {
  userId: string;
  friendId: string;
};

export const getUserRequest = (payload: string) => {
  return {
    type: USER_REQUESTING,
    payload,
  };
};

export const deleteMyUserRequest = (payload: { userId: string }) => {
  return {
    type: MY_USERS_DELETE_REQUESTING,
    payload,
  };
};

// utilisé ?
export const focusProfile = () => {
  return {
    type: USER_FOCUS,
  };
};

// utilisé ?
export const unfocusProfile = () => {
  return {
    type: USER_UNFOCUS,
  };
};

export const userModifyRequesting = (payload: {
  id: string;
  payload: { actionState: string; actionSeenDate: Date };
}) => {
  return {
    type: USER_MODIFY_REQUESTING,
    id: payload.id,
    payload: payload.payload,
  };
};

/*
export const addFriend = (payload: addFriendType) => {
  return {
    type: USER_FRIEND_REQUEST,
    payload,
  };
};

export const hideFriendRequest = (payload: hideFriendRequestType) => {
  return {
    type: USER_HIDE_FRIEND_REQUEST,
    payload,
  };
};*/

// utilisé ?
export const modifyUserRequest = (id: string, payload: payloadType) => {
  return {
    type: USER_MODIFY_PICTURE,
    id,
    payload,
  };
};

/*
  {
    challengeReminderTime: {hour: number, minute: number},
    hasChallengeReminder: boolean,
    hasNotificationsEnabled: boolean,
    picture: string,
    bio: string,
      firstName:string,
      lastName:string,
      jobDuration:,
      manager:,
      jobDescription:string,
      birthDate:,
      mbti:string,
      disc:string,
      language:string,
  }
*/
// beaucoup trop de chose modifier avec cette fonction j'ai pas tout mis
export const modifyUser = payload => {
  return {
    type: USER_MODIFY,
    payload,
  };
};

// on ne sais pas ce que le user est
export const setUser = user => {
  return {
    type: USER_SET,
    user,
  };
};

// utilisé ?
export const unsetUser = () => {
  return {
    type: USER_UNSET,
  };
};

export const addDeviceId = (payload: { userId: string }) => {
  return {
    type: USER_ADD_DEVICE_ID,
    payload,
  };
};

export const sendPulseNotification = (payload: {
  userId: string;
  friendId: string;
}) => {
  return {
    type: USER_SEND_PULSE_NOTIFICATION_REQUESTING,
    payload,
  };
};

export const getCompanyLogoRequest = (payload: { clientId: string }) => {
  return {
    type: USER_GET_COMPANY_LOGO_REQUESTING,
    payload,
  };
};

/*
userId,
hasChallengeReminder?,
hasNotificationsEnabled?,
hasNotificationsEnabledCheckDate?,
 */
// en fait c'est comme la modifyUser
export const updateUserWithoutResponseRequest = payload => {
  return {
    type: UPDATE_USER_WITHOUT_RESPONSE_REQUESTING,
    payload,
  };
};
